import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../../modules/infra/i18n';
import Modal from '../../../common/Modal';
import Money from '../../../common/money';

const TaxBreakdownModal = ({
  serviceGrossTotal,
  productGrossTotal,
  newMembershipGrossTotal,
  recurringMembershipGrossTotal,
  grossTotal,
  isMembershipDataVisible,
  close,
}) => (
  <Modal
    close={close}
    showCloseButton
    title={t('reports:dashboard.gross_sales_breakdown')}
    automationIdPart="grossSalesBreakdownModal"
  >
    <div className="u-flex o-flexbox--justify-space-between u-bg-white c-plain-text u-ph+ u-pv u-mb- u-mt+">
      <span>{t('reports:dashboard.service_sales')}</span>
      <Money automationId="text:serviceGrossTotalAmount">{serviceGrossTotal}</Money>
    </div>
    <div className="u-flex o-flexbox--justify-space-between u-bg-white c-plain-text u-ph+ u-pv u-mb-">
      <span>{t('reports:dashboard.product_sales')}</span>
      <Money automationId="text:productGrossTotalAmount">{productGrossTotal}</Money>
    </div>
    <Fragment display-if={isMembershipDataVisible}>
      <div className="u-flex o-flexbox--justify-space-between u-bg-white c-plain-text u-ph+ u-pv u-mb-">
        <span>{t('reports:dashboard.new_membership_sales')}</span>
        <Money automationId="text:newMembershipGrossTotalAmount">{newMembershipGrossTotal}</Money>
      </div>
      <div className="u-flex o-flexbox--justify-space-between u-bg-white c-plain-text u-ph+ u-pv u-mb-">
        <span>{t('reports:dashboard.recurring_membership_sales')}</span>
        <Money automationId="text:recurringMembershipGrossTotalAmount">{recurringMembershipGrossTotal}</Money>
      </div>
    </Fragment>
    <div className="u-type--semibold u-flex o-flexbox--justify-space-between u-bg-white c-plain-text u-ph+ u-pv u-mb+">
      <span>{t('reports:dashboard.total_collected')}</span>
      <Money automationId="text:grossTotalAmount">{grossTotal}</Money>
    </div>
  </Modal>
);

TaxBreakdownModal.propTypes = {
  close: PropTypes.func.isRequired,
  serviceGrossTotal: PropTypes.number.isRequired,
  productGrossTotal: PropTypes.number.isRequired,
  newMembershipGrossTotal: PropTypes.number.isRequired,
  recurringMembershipGrossTotal: PropTypes.number.isRequired,
  grossTotal: PropTypes.number.isRequired,
  isMembershipDataVisible: PropTypes.bool.isRequired,
};

export default TaxBreakdownModal;
